import Phaser from "phaser";
import Game from "./Game";

export default class FramesCollector extends Phaser.GameObjects.Container {
  constructor(scene, span) {
    super(scene);
    this.scene = scene;
    this.span = span;
    // Controlla se ha già caricato le immagini (cosa che capita solo con lo span più piccolo)
    this.loaded = [];
    for (let x = 0; x < Game.frames; x++) {
      if (span === Game.spans[0]) {
        const img = this.scene.add.image(0, 0, "image" + Game.spans[0] + "_" + x);
        this.add(img);
        this.loaded.push({ image: img, loaded: true, loading: false, shown: true });
      } else {
        this.loaded.push({ image: null, loaded: false, loading: false, shown: false });
      }
    }
    this.currentFrame = 0;
  }

  init(frame) {
    // Si ridimensiona in base allo span
    this.setDefaultSize();
    this.showFrame(frame);
  }

  setDefaultSize() {
    const scale = Game.HEIGHT / this.span;
    this.setScale(scale);
    this.x = Game.WIDTH / 2;
    this.y = Game.HEIGHT / 2;
    this.originalScale = scale;
  }

  setFrame(frame) {
    this.showFrame(frame);
  }

  showFrame(n) {
    this.currentFrame = n;
    for (let x = 0; x < this.loaded.length; x++) {
      if (x !== n) {
        if (this.loaded[x].loaded) {
          if (this.loaded[x].shown) {
            this.loaded[x].image.visible = false;
          }
        }
      } else {
        if (!this.loaded[x].loaded) {
          if (!this.loaded[x].loading) {
            this.loadFrames(x);
          }
        } else {
          if (this.loaded[x].loaded) {
            if (this.loaded[x].shown) {
              this.loaded[x].image.visible = true;
            } else {
              this.loaded[n].image = this.scene.add.image(0, 0, "image" + this.span + "_" + n);
              this.add(this.loaded[n].image);
              this.loaded[x].shown = true;
              this.loaded[x].image.visible = true;
            }
            //console.log("Showing frame " + this.span + ": ", x);
          }
        }
      }
    }
  }

  loadFrames(frame) {
    // Carica sempre quello corrente, quello precedente e quello successivo
    this.loadFrame(frame);
    this.loadFrame(this.getPreviousFrame(frame));
    this.loadFrame(this.getNextFrame(frame));
  }

  getPreviousFrame(n) {
    return n === 0 ? Game.frames - 1 : n - 1;
  }

  getNextFrame(n) {
    return n === Game.frames - 1 ? 0 : n + 1;
  }

  loadFrame(frame) {
    // Ottimizzazione, da tenere sotto controllo (intendo this.visible)
    if (this.visible) {
      this.loaded[frame].loading = true;
      //console.log("Loading frame " + "image" + this.span + "_" + frame);
      //console.log("dist/assets/views/" + this.span + "/" + Game.prefix + Game.to3(frame) + Game.suffix);
      this.scene.load.image("image" + this.span + "_" + frame, Game.folderPath + this.span + "/" + Game.prefix + Game.to3(frame) + Game.suffix);
      this.scene.load.once("complete", this.frameLoaded.bind(this, frame));
      this.scene.load.start();
    }
  }

  frameLoaded(frame) {
    //console.log("Frame loaded " + this.span + ": ", frame);
    //if (frame === this.currentFrame) {
    //this.loaded[frame].image = this.scene.add.image(0, 0, "image" + this.span + "_" + frame);
    //this.add(this.loaded[frame].image);
    //}
    this.loaded[frame].loaded = true;
    this.loaded[frame].loading = false;
    this.showFrame(this.currentFrame);
  }

  zoomIn(zoomFactor) {
    this.setScale(this.originalScale * zoomFactor);
  }

  zoomOut(zoomFactor) {
    this.setScale(this.originalScale * zoomFactor);
  }
}
